import { useMediaQuery } from '@mantine/hooks';

/**
 * Canonical hook for detecting mobile devices.
 * Uses CSS media query with Mantine's 'sm' breakpoint (48em = 768px).
 *
 * Note: For Three.js canvas components that need viewport-based detection,
 * use `const { size } = useThree(); const isMobile = size.width < 768;`
 * since the canvas size may differ from CSS viewport.
 */
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 48em)') ?? false;
}
